import { useQuery } from 'react-query'
import { api } from '../api'
import { OpenAccountsResponse } from '../../Interfaces/openAccount'

export type OpenAccountsFilters = {
  start_date?: string
  end_date?: string
  client?: string
  type?: 'ALL' | 'DESPESA' | 'RECEITA'
  category?: string
}

export function useOpenAccounts(filters: OpenAccountsFilters) {
  return useQuery(['open-accounts', filters], async () => {
    const { data } = await api.get<OpenAccountsResponse>('/financial/open-accounts', {
      params: filters,
    })

    return data
  })
}
